<div role="tablist" class="aa-tabgroup" [ngClass]="customCls" [class.justified]="justified">
  @for (tab of tabs; track tab) {
    <div class="aa-tab" [class.disabled]="tab.disabled" [class.active]="tab.active">
      <div [style.height.px]="height" class="aa-tab-title" (click)="selectTab(tab);">
        {{tab.title}}<ng-template [ngTemplateOutlet]="$safeNavigationMigration(tab.titleTpl?.templateRef)"></ng-template>
      </div>
      <div class="aa-tab-border"></div>
    </div>
  }
</div>
<div class="aa-tab-content">
  @for (tab of tabs; track tab) {
    @if (tab.active) {
      <div role="tabpanel" [attr.aria-labelledby]="tab.id" id="{{tab.id}}-panel">
        <ng-template [ngTemplateOutlet]="$safeNavigationMigration(tab.contentTpl?.templateRef)"></ng-template>
      </div>
    }
  }
</div>
